import React, { useState, useEffect } from "react";
import "../css/LoginPage.css";
import { Link, useNavigate } from "react-router-dom";
import dogCatImage from "../assets/view-cats-dogs-showing-friendship 1.png";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../redux/actions/userActions";


const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, user } = useSelector((state) => state.auth);

  const handleSubmit = (e) => {
    e.preventDefault();

    let isValid = true;

    // Validate email
    if (!email) {
      setEmailError("Please enter email");
      isValid = false;
    } else if (!email.includes("@")) {
      setEmailError("Enter a valid email");
      isValid = false;
    } else {
      setEmailError("");
    }

    // Validate password
    if (!password) {
      setPasswordError("Please enter password");
      isValid = false;
    } else {
      setPasswordError("");
    }

    if (isValid) {
      // ✅ Call Redux thunk (server call)
      dispatch(loginUser({ email, password }));
    }
  };

  // If login successful, navigate to Dashboard
  useEffect(() => {
    if (user) {
      navigate("/Dashboard");
    }
  }, [user, navigate]);

  return (
    <div className="login-page-container">
      <div className="login-page-left">
        <h2 className="login-page-header">
          Log In to PawFriends – Simplify Pet Care Management
        </h2>
        <img className="login-page-image" src={dogCatImage} alt="Dog and Cat" />
      </div>
      <div className="login-page-right">
        <h2 className="login-page-right-header">Log In</h2>
        <form className="login-page-form" onSubmit={handleSubmit}>
          <label className="login-page-form-label">Email</label>
          <input
            className="login-page-form-input"
            type="email"
            placeholder="designer@gmail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {emailError && <p className="error-message">{emailError}</p>}

          <label className="login-page-form-label">Password</label>
          <input
            className="login-page-form-input"
            type="password"
            placeholder="********"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {passwordError && <p className="error-message">{passwordError}</p>}

          {error && <p className="error-message">{error}</p>}

          {/* <p className="login-page-forgot">
            <Link to="/forgot-password">Forgot Password?</Link>
          </p> */}
          <br />

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Logging in..." : "Log In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
